import React,{useState} from "react";
import "../../examReview.scss";
import logo from "../Rectangle 2.svg";
import { Select } from "@mantine/core";
import { useDetails } from "../../DetailsContext";
import backbtn from "../../../../../assets/img/Images/backbtn.svg";
import { Modal } from "@mantine/core";
import { useDisclosure } from '@mantine/hooks';
import { useNavigate,useLocation } from "react-router-dom";
const Header = ({solutionActive ,setSolutionActive,firstRadio,setFirstRadio}) => {
  const [opened, { open, close }] = useDisclosure(false)
  const { details, setDetails } = useDetails();
  const location = useLocation();
  const id = location?.state?.id;
  console.log(id,"checking here")
  const navigate=useNavigate();
  return (
    <div className="HeaderDiv">
      <div className="logoHeading">
        <div className="img-container">
          <img src={logo} />
        </div>
        <div className="RightText">
          <div  className="btn" onClick={open}>Re-attempt</div>
          <div onClick={()=>{
            setSolutionActive(!solutionActive)
            setDetails(false)
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });

          }}  className="btn">{solutionActive?"Analytics":"Solution"}</div>
        </div>
        <Modal
        opened={opened}
        onClose={close}
        centered
        withCloseButton={false}
        overlayProps={{
          backgroundOpacity: 0.25,
          blur: 3,
        }}
        
          
        
      >
        <div className="modalmaindiv">
          <div className="text1">
          Are you sure you wish to
re-attempt the test?
          </div>
          <div onClick={()=>navigate(`/exam/preview/${id}`)} className="modalbtndiv">
             <h3>Re-attempt</h3>
          </div>
          <div onClick={close} className="laterdiv">
            <div>
              
            Later
            </div>
            </div>
        </div>
        {/* Modal content */}
      </Modal>

      </div>
      {solutionActive ||details && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "3.5rem",
            marginTop: "0.3rem",
            cursor: "pointer",
          }}
          onClick={() => {
            setDetails(false) 
            setSolutionActive(false)
          }
          }
        >
          <img src={backbtn} alt="" />
          Back
        </div>
      )}
      <div className="examHeading">
        <div className="examTest">SBI Clerk Mock Test (Full)</div>
        {!details &&!solutionActive && (
          <div className="dropDown">
            Category
            <Select
              placeholder="Cutoff"
              data={["General", "EWS", "OBC", "SC", "ST"]}
            />
          </div>
        )}
        {details && (
          <div className="dropDown">
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor:"pointer"
                }}
              >
                <label
                  className="circle-checkbox"
                  // onClick={()=>setDetails(!details)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "0.5rem",
                    cursor:"pointer"
                  }}
                >
                  <input
                    type="radio"
                    name="markingButton"
                    style={{
                      height: "1rem",
                      width: "1rem",
                      transform: "scale(1.1)",
                      cursor:"pointer"
                    }}
                    checked={firstRadio === true}
                    onChange={() => setFirstRadio(true)}
                  />
                  <span className="" style={{ width: "10rem" }}>
                    {" "}
                    {
                      console.log(details,"sec tion","questionhere")
                    }
                    {details?"Sectional View ":"Question View"}
                  </span>
                </label>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor:"pointer"
                }}
              >
                <label
                  className="circle-checkbox"
                  // onClick={()=>setDetails(!details)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "0.5rem",
                    cursor:"pointer"
                  }}
                >
                  <input
                    type="radio"
                    name="markingButton"
                    style={{
                      height: "1rem",
                      width: "1rem",
                      transform: "scale(1.1)",
                      cursor:"pointer"
                    }}
                    checked={firstRadio === false}
                    onChange={() => setFirstRadio(false)}
                  />
                  <span style={{ width: "8rem" }}> {details?"Topic View ":"Grid View"}</span>
                </label>
              </div>
            </div>
          </div>
        )}
          {solutionActive &&!details && (
          <div className="dropDown">
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor:"pointer"
                }}
              >
                <label
                  className="circle-checkbox"
                  // onClick={()=>setDetails(!details)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "0.5rem",
                    cursor:"pointer"
                  }}
                >
                  <input
                    type="radio"
                    name="markingButton"
                    style={{
                      height: "1rem",
                      width: "1rem",
                      transform: "scale(1.1)",
                      cursor:"pointer"
                    }}
                    checked={firstRadio === true}
                    onChange={() => setFirstRadio(true)}
                  />
                  <span className="" style={{ width: "10rem" }}>
                    {" "}
                   
                    {details?"Sectional View ":"Question View"}
                  </span>
                </label>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor:"pointer"
                }}
              >
                <label
                  className="circle-checkbox"
                  // onClick={()=>setDetails(!details)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "0.5rem",
                    cursor:"pointer"
                  }}
                >
                  <input
                    type="radio"
                    name="markingButton"
                    style={{
                      height: "1rem",
                      width: "1rem",
                      transform: "scale(1.1)",
                      cursor:"pointer"
                    }}
                    checked={firstRadio === false}
                    onChange={() => setFirstRadio(false)}
                  />
                  <span style={{ width: "8rem" }}> {details?"Topic View ":"Grid View"} </span>
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
